var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppIconUpload'),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),(_vm.app.cover)?[_c('AppCoverUpload'),_vm._v(" "),_c('hr',{staticClass:"divider"})]:_vm._e(),_vm._v(" "),_c('AppScreenshots'),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('AppVideoShots')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }